import { getCMSConfig } from '../cms';
import { convertToPriceString, formatTariffDetails, replaceAllPlaceholders } from '../formatter';
import { ProductPlaceholder } from '../../enums/placeholder';
import { JarvisProduct } from '@vfde-sails/avc-core';
import { HomesPassedType } from '../../enums/product';

export const getPriceSubline = (
    tariff: JarvisProduct | undefined,
    isRegularFiber: boolean,
    isContentEnabled: boolean,
    homesPassedType?: HomesPassedType,
) => homesPassedType === HomesPassedType.BHS
    ? getCMSConfig().offerSummaryCard.homesPassedBHS.subline
    : tariff && isContentEnabled
        ? formatTariffDetails(tariff.download, tariff.upload)
        : isRegularFiber
            ? getCMSConfig().offerSummaryCard.fiberAvailable.subline
            : getCMSConfig().offerSummaryCard.notAvailable.subline;

export const getPriceLegalText = (product: JarvisProduct) => {
    const config = getCMSConfig().offerSummaryCard.legalText;
    const { durationLine, installationPriceLine } = config;

    const installationLine = installationPriceLine.text +
        installationPriceLine.tooltip.element;

    return [
        replaceAllPlaceholders(installationLine, {
            [ProductPlaceholder.INSTALLATION_FEE]: typeof product.installationFee?.price === 'number'
                ? convertToPriceString(product.installationFee.price) : '',
        }),
        replaceAllPlaceholders(durationLine, {
            [ProductPlaceholder.DURATION]: product.duration.toString(),
        }),
    ];
};
